import React, { useState } from "react";
import { FaAutoprefixer } from "react-icons/fa6";
import { HiMenuAlt3 } from "react-icons/hi";
import { MdOutlineDashboard, MdProductionQuantityLimits } from "react-icons/md";
import { TfiLayoutSlider } from "react-icons/tfi";

import { RiGalleryFill } from "react-icons/ri";
import { RxActivityLog } from "react-icons/rx";
import { GrCatalogOption } from "react-icons/gr";

import { Link, NavLink } from "react-router-dom";




const Sidebar = () => {
  const menus = [
    { name: "Dashboard", link: "/", icon: MdOutlineDashboard },
    { name: "Home", link: "/Home", icon: MdOutlineDashboard },
    { name: "Slider", link: "/slider", icon: TfiLayoutSlider },
    { name: "About", link: "/about", icon: FaAutoprefixer  },
    { name: "Gallery", link: "/gallery", icon: RiGalleryFill },
    { name: "Cataloge", link: "/cataloge", icon: GrCatalogOption },
    { name: "Activity", link: "/activity", icon: RxActivityLog  },
    { name: "Product", link: "/product", icon: MdProductionQuantityLimits },
    { name: "Contact", link: "/contact", icon: MdProductionQuantityLimits },
    // { name: "Product", link: "/product", icon: MdProductionQuantityLimits },

    // { name: "Log Out", link: "/logout", icon: MdOutlineDashboard },
    
  ];
  const [open, setOpen] = useState(true);
  return (
    <section className="flex gap-6">
      <div
        className={`bg-[#0e0e0e]  min-h-screen ${
          open ? "w-72" : "w-16"
        } duration-500 text-gray-100 px-4`}
      >
        <div className="py-3 flex justify-end">
          <HiMenuAlt3
            size={26}
            className="cursor-pointer"
            onClick={() => setOpen(!open)}
          />
        </div>
        <div className="mt-4 flex flex-col gap-4 relative">
          {menus?.map((menu, i) => (
            <NavLink
              to={menu?.link}
              key={i}
              className={({isActive})=>
                isActive ?"group flex items-center text-sm  gap-3.5 font-medium p-2 bg-slate-800 hover:bg-gray-800 rounded-md":"group flex items-center text-sm  gap-3.5 font-medium p-2 hover:bg-gray-800 rounded-md"
              }
              
            >
              <div>{React.createElement(menu?.icon, { size: "20" })}</div>
              <h2
                style={{
                  transitionDelay: `${i + 3}00ms`,
                }}
                className={`whitespace-pre duration-500 ${
                  !open && "opacity-0 translate-x-28 overflow-hidden"
                }`}
              >
                {menu?.name}
              </h2>
              <h2
                className={`${
                  open && "hidden"
                } absolute left-48 bg-white font-semibold whitespace-pre text-gray-900 rounded-md drop-shadow-lg px-0 py-0 w-0 overflow-hidden group-hover:px-2 group-hover:py-1 group-hover:left-14 group-hover:duration-300 group-hover:w-fit  `}
              >
                {menu?.name}
              </h2>
            </NavLink>
          ))}
        </div>
      </div>
      
    </section>
  );
};

export default Sidebar;